exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".input-autocomplete{margin-bottom:32px}.vuetify-editable-address-card{margin-bottom:20px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-editable-address-card.vue"],"names":[],"mappings":"AACA,oBACE,kBAAoB,CACrB,AACD,+BACE,kBAAoB,CACrB","file":"vuetify-editable-address-card.vue","sourcesContent":["\n.input-autocomplete {\n  margin-bottom: 32px;\n}\n.vuetify-editable-address-card {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fb5ae64","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vuetify-editable-address-card.vue
// module id = 674
// module chunks = 0 1 2 3